import { render, staticRenderFns } from "./modify-customer-point-modal.vue?vue&type=template&id=7b341278"
import script from "./modify-customer-point-modal.vue?vue&type=script&lang=js"
export * from "./modify-customer-point-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports